import React, { useCallback } from "react";
import { Checkbox } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import infoIcon from "../../images/infoIcon.svg";

const useStyles = makeStyles(() => ({
  noResults: {
    margin: "14px 16px",
    fontSize: "12px",
    color: "grey",
    display: "flex",
    alignItems: "flex-start",
  },
  row: {
    padding: "8px 16px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    minHeight: 40,
    borderBottom: "1px solid #f0f0f0",
    "&:hover": { backgroundColor: "#f5f5f5" },
    "&:last-child": { borderBottom: "none" },
  },
  checkbox: {
    padding: "0 8px 0 0",
    "& .MuiSvgIcon-root": { fontSize: 18 },
  },
  label: {
    fontSize: 12,
    fontFamily: "Nunito, sans-serif",
    userSelect: "none",
    flex: 1,
    lineHeight: 1.4,
  },
}));

export const MultiSelectList = ({
  data = [],
  handleSelection,
  selected = [],
}) => {
  const classes = useStyles();

  const isSelected = useCallback(
    (element) => selected.some((el) => el.id === element.id),
    [selected]
  );

  if (!data || data.length === 0) {
    return (
      <div className={classes.noResults}>
        <img
          src={infoIcon}
          alt="Info"
          style={{ marginRight: 6, flexShrink: 0 }}
        />
        <p>No Result Found, Try Using Different Keywords</p>
      </div>
    );
  }

  return (
    <>
      {data.map((option) => {
        const checked = isSelected(option);
        const onRowClick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          handleSelection(!checked, option);
        };

        return (
          <div
            key={option.id}
            className={classes.row}
            onClick={onRowClick}
            role="option"
            aria-selected={checked}
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") onRowClick(e);
            }}
          >
            <Checkbox
              className={classes.checkbox}
              name={option.displayName}
              color="primary"
              size="small"
              checked={checked}
              readOnly
              tabIndex={-1}
              inputProps={{ "aria-label": `Select ${option.displayName}` }}
            />
            <span className={`${classes.label} font-nunito_sans`}>
              {option.displayName}
            </span>
          </div>
        );
      })}
    </>
  );
};
